var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    {
      staticClass: "header-combined",
      class: {
        "header-combined--two-row": ["type_5", "type_6"].includes(
          _vm.shopTheme
        ),
      },
    },
    [
      _vm.shopTheme === "type_1"
        ? [
            _c("HeaderMenuType1", {
              attrs: { loading: _vm.loading, data: _vm.data },
            }),
          ]
        : _vm.shopTheme === "type_2"
        ? [
            _c("HeaderMenuType2", {
              attrs: { loading: _vm.loading, data: _vm.data },
            }),
          ]
        : _vm.shopTheme === "type_3"
        ? [
            _c("HeaderMenuType3", {
              attrs: { loading: _vm.loading, data: _vm.data },
            }),
          ]
        : _vm.shopTheme === "type_4"
        ? [
            _c("LogoBar4", {
              staticClass: "d-md-none header-logo-area",
              attrs: { loading: _vm.loading, data: _vm.data },
            }),
            _vm._v(" "),
            _vm.$route.name === "Login"
              ? _c("HeaderMenuLogin", {
                  staticClass: "d-none d-md-flex header-nav-area",
                  attrs: { loading: _vm.loading, data: _vm.data },
                })
              : _c("HeaderMenu", {
                  staticClass: "d-none d-md-flex header-nav-area",
                  attrs: { loading: _vm.loading, data: _vm.data },
                }),
          ]
        : _vm.shopTheme === "type_5"
        ? [
            _c("LogoBar6", {
              staticClass: "d-md-none header-logo-area",
              attrs: { loading: _vm.loading, data: _vm.data },
            }),
            _vm._v(" "),
            _c("HeaderMenuType6", {
              staticClass: "d-none d-md-block header-nav-area",
              attrs: { loading: _vm.loading, data: _vm.data },
            }),
          ]
        : _vm.shopTheme === "type_6"
        ? [
            _c("LogoBar6", {
              staticClass: "d-md-none header-logo-area",
              attrs: { loading: _vm.loading, data: _vm.data },
            }),
            _vm._v(" "),
            _c("HeaderMenuType6", {
              staticClass: "d-none d-md-block header-nav-area",
              attrs: { loading: _vm.loading, data: _vm.data },
            }),
          ]
        : _vm.shopTheme === "type_7"
        ? [
            _c("HeaderMenuType7", {
              attrs: { loading: _vm.loading, data: _vm.data },
            }),
          ]
        : [
            _c("LogoBar4", {
              staticClass: "d-md-none header-logo-area",
              attrs: { loading: _vm.loading, data: _vm.data },
            }),
            _vm._v(" "),
            _vm.$route.name === "Login"
              ? _c("HeaderMenuLogin", {
                  staticClass: "d-none d-md-flex header-nav-area",
                  attrs: { loading: _vm.loading, data: _vm.data },
                })
              : _c("HeaderMenu", {
                  staticClass: "d-none d-md-flex header-nav-area",
                  attrs: { loading: _vm.loading, data: _vm.data },
                }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }